// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j1-0";
export var actionModalContentContainer = "_j1-1";
export var createTagButton = "_j1-2";
export var footerContainer = "_j1-7";
export var fullWidthDivider = "_j1-3";
export var hasCreateTagButton = "_j1-4";
export var noCreateTagButton = "_j1-5";
export var tagsContainer = "_j1-6";
export var tagsModalContentContainer = "_j1-8";